import React from "react";
import type { Key } from "react-aria-components";

export type NodeCheckState = "checked" | "indeterminate" | "unchecked";

export interface TreeSelectionContextValue {
  getNodeState: (id: Key) => NodeCheckState;
}

export const TreeSelectionContext =
  React.createContext<TreeSelectionContextValue | null>(null);
